import React from 'react';
import {
  addPathToList,
  Disabled_Logo,
  File_type_recommended_area,
  highly_recommend_welcome,
  HotKey_Logo, iOS,
  launch_keyboard,
  launch_keyboard_app,
  Show_welcome_message,
  Upload_assets,
} from '../utils/DictionaryManagementUtils';
import { arrangeScreenInJson } from '../screens/ScreensOrdering';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import BreakLine from '../components/PanelsComponents/General/BreakLine';
import WarningMessage from '../components/PanelsComponents/Text/WarningMessage';
import UploadMenu from '../components/PanelsComponents/Upload/UploadMenu';

//= ========================================================================
const Panel_T01_launch_keyboard = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  simPlatform,
  language,
}) => {
  const { launch } = globJSON.configurations;
  const { keyboard } = launch;
  const editTextList = [
    'l_k_title',
    'l_k_message',
    'l_k_cancel',
    'got_it',
  ].filter(() => (simPlatform === iOS && true));
  const onValueChanged = (key, value) => {
    keyboard[key] = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={launch_keyboard}
      editTextList={addPathToList(editTextList, 'configurations/launch/keyboard/')}
      tooltipsTitles={launch.screens_ordering}
      paragraph={launch_keyboard_app}
      disableEditElements={simPlatform !== iOS}
      isHollow
      language={language}
      paddingVertical={25}
    >
      <SwitcherPanel
        text={Show_welcome_message}
        value={keyboard.access_to_bank_info_message}
        onValueChanged={(value) => {
          onValueChanged('access_to_bank_info_message', value);
        }}
      />
      {!keyboard.access_to_bank_info_message && <WarningMessage language={language}>{highly_recommend_welcome}</WarningMessage>}
    </FullPagePanel>
  );
};

export default Panel_T01_launch_keyboard;
